import {FunctionalComponent, h, createRef} from "preact";
import typingAnim from "./typingAnim";
import {useContext, useEffect} from "preact/hooks";
import {EFFECTS, EffectsContext} from "./effectsContext";
import {VoiceContext} from "./voiceContext";

const TextEffects: FunctionalComponent<{ disableEffects?: number[]; msgText: string; tickCallback: () => void }> = ({disableEffects, msgText, tickCallback}) => {
  const spanEl = createRef();
  const effectsContext = useContext(EffectsContext);
  const voiceContext = useContext(VoiceContext);

  const enabledEffects = effectsContext.getEnabledEffects();

    useEffect(() => {
      const fxPromises: Promise<boolean|void>[] = [];

      for (const fx of enabledEffects) {
        if (typeof disableEffects === 'undefined' || disableEffects.indexOf(fx.type) < 0) {
          if (fx.type === EFFECTS.TYPING_ANIMATION) {
            fxPromises.push(typingAnim(spanEl.current, msgText));
          } else if (fx.type === EFFECTS.SPEAK) {
            fxPromises.push(voiceContext.speak(msgText));
          }
        }
      }

      if (fxPromises.length) {
        Promise.all(fxPromises).then(tickCallback);
      } else {
        tickCallback();
      }
    }, [msgText]);

    if (effectsContext.willHandleRendering()) {
      return (<span ref={spanEl} />);
    }

    return <span dangerouslySetInnerHTML={{__html: msgText}} />;

}

export default TextEffects;
